import * as Tabs from "@radix-ui/react-tabs";
import { AnimatePresence, motion } from "motion/react";
import { ArrowDownRight } from "lucide-react";
import { apartments } from "../data/project";

export default function ApartmentShowcase() {
  return (
    <Tabs.Root className="apartment-root" defaultValue="studio">
      <Tabs.List className="apartment-tabs" aria-label="Tipologias">
        {Object.entries(apartments).map(([key, item]) => (
          <Tabs.Trigger value={key} key={key}>{item.label}</Tabs.Trigger>
        ))}
      </Tabs.List>
      {Object.entries(apartments).map(([key, item]) => (
        <Tabs.Content value={key} key={key} className="apartment-stage">
          <div className="apartment-image">
            <AnimatePresence mode="wait">
              <motion.img
                key={item.image}
                src={item.image}
                alt={item.alt}
                loading="lazy"
                initial={{ opacity: 0.25 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.4 }}
              />
            </AnimatePresence>
            <span>Imagem meramente ilustrativa</span>
          </div>
          <div className="apartment-info">
            <p className="section-label">{item.label}</p>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <div className="apartment-measure">{item.measure}</div>
            <ul>{item.features.map((feature) => <li key={feature}>{feature}</li>)}</ul>
            <a className="text-link light" href="#contato">Solicite as plantas detalhadas <ArrowDownRight aria-hidden="true" /></a>
          </div>
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
}
